import React, { createContext, useContext, useState } from 'react';

export interface FeedbackPanelData {
  type?: 'feedback';
  messageId: string;
  initialVote: 'like' | 'dislike';
  onSubmit: (vote: 'like' | 'dislike', text: string) => Promise<void>;
  onClose: () => void;
}

export interface AddMcpPanelData {
  type: 'add-mcp';
  editData?: {
    transactionId: string;
    name: string;
    description: string;
    url: string;
    tools?: string;
    headers?: string;
    hasHeaders?: boolean;
    needsUserCredentials?: boolean;
  };
  onSuccess?: () => void;
}

export interface ViewMcpPanelData {
  type: 'view-mcp';
  transactionId: string;
  name: string;
  description: string;
  url: string;
  tools?: string;
  headers?: string;
  hasHeaders?: boolean;
  needsUserCredentials?: boolean;
  createdBy: string;
  createdAt: string;
}

export type SidebarPanelData = FeedbackPanelData | AddMcpPanelData | ViewMcpPanelData;

interface FeedbackPanelContextValue {
  feedbackPanel: SidebarPanelData | null;
  setFeedbackPanel: (data: SidebarPanelData | null) => void;
}

const FeedbackPanelContext = createContext<FeedbackPanelContextValue>({
  feedbackPanel: null,
  setFeedbackPanel: () => {},
});

export const FeedbackPanelProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [feedbackPanel, setFeedbackPanel] = useState<SidebarPanelData | null>(null);
  return (
    <FeedbackPanelContext.Provider value={{ feedbackPanel, setFeedbackPanel }}>
      {children}
    </FeedbackPanelContext.Provider>
  );
};

export const useFeedbackPanel = () => useContext(FeedbackPanelContext);
